import Index from '@/pages/contacts/Index'
import List from '@/pages/contacts/List'
import Create from '@/pages/contacts/Create'
import Import from '@/pages/contacts/Import'
import Modify from '@/pages/contacts/Modify'
import ExtraCreate from '@/pages/contacts/ExtraCreate'
import ExtraModify from '@/pages/contacts/ExtraModify'

var serviceName = process.env.VUE_APP_SERVICE_NAME || 'Nichibyo'

export default {
  path: 'contact',
  component: Index,  
  children: [
    {
      path: 'index',
      component: List,
      props: () => ({serviceName: serviceName})
    },
    {
      path: 'create/:extraContactId',
      component: Create
    },
    {
      path: 'import',
      component: Import
    },
    {
      path: 'modify/:extraContactId/:id',
      component: Modify,
      props: () => ({serviceName: serviceName})
    },
    {
      path: 'extracreate',
      component: ExtraCreate
    },
    {
      path: 'extramodify/:id',
      component: ExtraModify
    }
  ]
}

